<template>
  <div
    key="home-options"
    v-if="loggedIn"
    class="flex items-center w-full h-full pr-[30px]"
  >
    <PreviousButton @click="goBack" :label="$t('modal.back')" />
    <div class="ml-auto flex items-center gap-2 relative">
      <!-- WAITING CONTENT META INFO -->
      <!-- <BaseAction icon="info" disabled /> -->
      <Transition name="fade">
        <div
          v-if="tooltipActive"
          class="absolute z-20 shadow px-2 py-1 text-2xs bg-gray-9 text-white top-0.5 right-[calc(100%+4px)] rounded whitespace-nowrap"
        >
          {{ $t(tooltipText) }}
        </div>
      </Transition>
      <BaseAction
        v-if="displayAiAction"
        icon="sparkles"
        label="AI"
        type="ai"
        :active="aiCollapseDisplayed"
        @click="emit('toggle-ai-collapse')"
      />
      <BaseAction
        v-if="diagnosticIsFocused"
        icon="project-diagram"
        :active="flowy"
        @mouseenter="toggleTooltip('display-flowy')"
        @mouseleave="toggleTooltip(null)"
        @click="toggleFlowy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAdminStore, useKnowledgeStore } from '@getmayday/vue-modules';
import useEntities from '../../composables/useEntities';
import { useRoute } from 'vue-router';
import PreviousButton from '../Library/PreviousButton.vue';

const adminStore = useAdminStore();
const knowledgeStore = useKnowledgeStore();
const configStore = useConfigStore();
const { goBack } = useEntities();
const route = useRoute();

const { loggedIn } = storeToRefs(adminStore);
const { flowy } = storeToRefs(configStore);
const { diagnosticIsFocused } = storeToRefs(knowledgeStore);

const props = defineProps({
  displayAiAction: {
    type: Boolean,
    default: false,
  },
  aiCollapseDisplayed: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle-ai-collapse']);

const toggleFlowy = () => {
  configStore.setFlowy(!flowy.value);
};

/*** TOOLTIPS ***/
let tooltipActive = ref(null as string | null);

const tooltipTextMap = {
  'expand-content': 'layout.expand-content',
  'display-flowy': 'flowy.tooltip',
} as Record<string, string>;

const tooltipText = computed(() => {
  if (!tooltipActive.value) return '';
  return tooltipTextMap[tooltipActive.value];
});

const toggleTooltip = (name: string | null) => {
  tooltipActive.value = name;
};
</script>
